import React from "react";
import Heart from "../icons/Heart";
import { makeStyles, createStyles, Box } from "@material-ui/core";

const useStyles = makeStyles(() =>
    createStyles({
        "@keyframes heartbeat": {
            "0%": {
                transform: "scale(1)"
            },
            "15%": {
                transform: "scale(1.1)"
            },
            "30%": {
                transform: "scale(1)"
            },
            "45%": {
                transform: "scale(1.15)"
            },
            "100%": {
                transform: "scale(1)"
            },
        },
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100vw',
            position: 'fixed',
            top: 0,
            left: 0,
            backgroundColor: "#f7f3ee", // beige_10 background color
            zIndex: 9999,
        },
        icon: {
            color: "#009ceb", // coronariaBlue
            height: "150px",
            width: "150px",
            animation: "$heartbeat 1s linear infinite",
        },
    })
);

const CallbackLoader: React.FC = (_props) => {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <Heart className={classes.icon} />
        </Box>
    );
};

export default CallbackLoader;